module.exports = require("@workbench-stack/platform-browser/lib/services/context-key/context-key-service");